export interface FBConnectedInstagramAccount {
  id: string;
  username: string;
  isPublished: boolean;
  profilePic?: string;
  followedByCount: number;
  followingCount: number;
}

export const exampleFBConnectedInstagramAccount: FBConnectedInstagramAccount = {
  id: '123',
  username: 'test-user',
  isPublished: false,
  profilePic: 'https://facebook.come/profile.png',
  followedByCount: 100,
  followingCount: 2,
};
